import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    ScrollView,
    TextInput,
    TouchableOpacity
} from 'react-native';

import {
    JDTouchable,
    JDImage,
    JDText,
} from '@jdreact/jdreact-core-lib';

import { NavBar } from '@ltfe/ltfe-core-lib';

import MovieItem from '../components/common/movie-item';
import PreWantMovieItem from '../components/common/pre-want-movieItem';
import Loading from '../components/common/loading';
import WifiOut from '../components/common/wifi-out';

import { get } from '../common/fetch';
import { mta, mtaPV, is_web, closeShare, fetchLocal, saveLocal } from '../common/utils';

import st from '../style/search.st';
import img from '../common/img';

class Search extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            keyWord: '',
            noResult: false,
            loading: false,
            wifiOut: false,
            historyWord: [],
            cinemas: [],
            movies: []
        };
        this.goBack = this.goBack.bind(this);
        this.moreCinema = this.moreCinema.bind(this);
        this.saveKeyWord = this.saveKeyWord.bind(this);
        this.close = this.close.bind(this);
        this.refresh = this.refresh.bind(this);
        this.saveWordAndJump = this.saveWordAndJump.bind(this);
    }

    render() {
        const { keyWord, historyWord, noResult, loading, wifiOut, cinemas, movies } = this.state;

        const cinemaListCopy = cinemas.slice(0, 10);

        return (
            <View style={ st.search_container }>
                {/* 顶部搜索框 */}
                <View style={ st.search_wrap }>
                    <View style={ st.search }>
                        <JDImage style={ st.search_img } source={ img.search } />
                        <TextInput
                            placeholder="找影院, 电影"
                            underlineColorAndroid="transparent"
                            placeholderTextColor="#898989"
                            onChangeText={ (keyWord) => this.textChange(keyWord) }
                            onKeyPress={ this.webSaveKeyWord }
                            onSubmitEditing={ null }
                            onFocus={ () => mta('SearchInput', 'Search') }
                            ref='textInput'
                            style={ st.input }
                            value={ keyWord }
                        />
                        {keyWord.length > 0 &&
                            <TouchableOpacity
                                style={ st.close }
                                activeOpacity={ 0.5 }
                                onPress={ this.close }
                            >
                            </TouchableOpacity>
                        }
                    </View>
                    <TouchableOpacity
                        activeOpacity={ 0.5 }
                        onPress={ this.goBack }
                    >
                        <JDText style={ st.cancel }>取消</JDText>
                    </TouchableOpacity>
                </View>
                {!loading && !wifiOut &&
                    <ScrollView
                        showsVerticalScrollIndicator={ false }
                        keyboardShouldPersistTaps={ true }
                        keyboardDismissMode='on-drag'
                        style={ st.main }
                    >
                        {/* 影片列表 */}
                        {movies.length > 0 && !!keyWord &&
                            <View style={ st.movie_wrap }>
                                {cinemas.length > 0 && <JDText style={ [st.title, st.movie_title] }>电影</JDText>}
                                {movies.map((item, index) => {
                                    return item.canPreOrder == 2 ? <MovieItem from="search" key={ index } saveWordAndJump={ this.saveWordAndJump } movieInfo={ item } /> : <PreWantMovieItem saveWordAndJump={ this.saveWordAndJump } key={ index } from="search" movieInfo={ item } />;
                                })}
                            </View>
                        }
                        {/* 影院列表 */}
                        {cinemaListCopy.length > 0 && !!keyWord &&
                            <View style={ [st.common_container, st.cinema_wrap] }>
                                {movies.length > 0 && <JDText style={ st.title }>影院</JDText>}
                                {cinemaListCopy.map((item, index) => {
                                    return (
                                        <TouchableOpacity
                                            key={ index }
                                            activeOpacity={ 0.5 }
                                            style={ st.cinema_item_wrap }
                                            onPress={ () => this.toMovieList(item.cinemaId) }
                                        >
                                            <View style={ st.cinema_name_price_wrap }>
                                                <JDText style={ st.cinema_name }>{item.cinemaName}</JDText>
                                                <JDText style={ st.cinema_price }>
                                                    &yen;{item.planPrice / 100}
                                                    <JDText style={ st.cinema_distance }>起</JDText>
                                                </JDText>
                                            </View>
                                            <View style={ st.cinema_address_wrap }>
                                                <JDText
                                                    style={ st.cinema_address }
                                                    numberOfLines={ 1 }
                                                >
                                                    {item.address}
                                                </JDText>
                                                <JDText style={ st.cinema_km }>{item.cinemaDistanceStr}</JDText>
                                            </View>
                                        </TouchableOpacity>
                                    );
                                })}
                                {(cinemas.length > 10) &&
                                    <TouchableOpacity activeOpacity={ 0.5 } style={ st.see_more_wrap } onPress={ this.moreCinema }>
                                        <View style={ st.see_more_common }>
                                            <JDText style={ st.see_more }>查看全部{cinemas.length}家影院</JDText>
                                        </View>
                                    </TouchableOpacity>
                                }
                            </View>
                        }
                        {/* 历史记录 */}
                        {!keyWord &&
                            <View style={ [st.common_container, st.history_wrap] }>
                                {historyWord.map((item, index) => {
                                    return (
                                        <TouchableOpacity
                                            activeOpacity={ 0.5 }
                                            key={ index }
                                            style={ [st.history_word_wrap, st.common_wrap] }
                                            onPress={ () => this.historyItemPress(item) }
                                        >
                                            <JDText style={ st.history_word }>{item}</JDText>
                                            <JDTouchable
                                                onPress={ () => this.removeWord(item) }
                                                style={ st.history_remove }
                                            >
                                                <JDImage style={ st.close_icon } source={ img.close } />
                                            </JDTouchable>
                                        </TouchableOpacity>
                                    );
                                })}
                            </View>
                        }
                        {/* 无搜索结果 */}
                        {noResult && !!keyWord && movies.length === 0 && cinemas.length === 0 &&
                            <View style={ st.no_result_wrap }>
                                <View style={ st.no_result }>
                                    <JDText style={ st.no_result_text }>抱歉，没有搜索到相关结果</JDText>
                                </View>
                            </View>
                        }
                    </ScrollView>
                }
                {loading &&
                    <Loading contentStyle={ { flex: 1 } } />
                }
                {wifiOut &&
                    <WifiOut refresh={ this.refresh } contentStyle={ { flex: 1 } } />
                }
            </View>
        );
    }

    componentDidMount() {
        storage.load({ key: 'historyWord' }).then((res) => {
            if (res) {
                this.setState({ historyWord: res });
            }
        }).catch(e => {
            console.log(e);
        });
        document.title = '搜索';
        closeShare();
        const keyWord = fetchLocal('keyWord');

        if (keyWord) {
            this.setState({ keyWord: keyWord }, () => {
                this.textChange(this.state.keyWord);
            });
        }
        setTimeout(() => {
            this.refs.textInput.refs.input.focus();
        }, 100);
    }

    componentDidFocus() {
        mtaPV('Search');
    }

    textChange(keyWord, callback = function() {}) {
        keyWord = keyWord.trim();
        if (!keyWord) {
            this.setState({ loading: false, noResult: false, wifiOut: false, keyWord, movies: [], cinemas: [] });

            return;
        }
        this.setState({ loading: true, keyWord, movies: [], cinemas: [] });
        let cur_city, lbs;

        cur_city = JSON.parse(JSON.stringify(this.props.cur_city));
        const movieCityHistory = fetchLocal('movieCityHistory');

        cur_city = (movieCityHistory && movieCityHistory.rawData[0]) || {};
        lbs = fetchLocal('lbs');
        const data = {
            keyWord,
            cityId: cur_city.cityId,
            lon: 0,
            lat: 0
        };

        data.lon = lbs && lbs.lon;
        data.lat = lbs && lbs.lat;
        get('searchCinemaMovie', data, true).then((res) => {
            const cinemas = res.data.cinemas || [];

            const movies = res.data.movies || [];

            if (cinemas.length > 0 || movies.length > 0) {
                this.setState({ cinemas, movies, loading: false, noResult: false });
                this.props.dispatch({
                    type: 'cinema_change',
                    cinemaList: cinemas
                });
                
                const hasEmpty = movies.some(item => !item.jdPicUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'searchCinemaMovie',message:'数据未返回图片地址！'}, 3)
                }
                callback(keyWord);
            } else {
                this.setState({ noResult: true, loading: false });
            }
        }, () => {
            this.setState({ loading: false, wifiOut: true });
        }).catch(() => {
            this.setState({ loading: false, wifiOut: true });
        });
    }

    historyItemPress(value) {
        this.setState({ keyWord: value });
        mta('SearchRecord', 'Search', value);
        is_web ? this.refs.textInput.refs.input.blur() : this.refs.textInput.blur();
        this.textChange(value);
    }

    removeWord(text) {
        mta('SearchRecordDelete', 'Search', text);
        this.refs.textInput.refs.input.blur();
        const historyWord = this.state.historyWord.slice(0);

        historyWord.splice(historyWord.indexOf(text), 1);
        this.setState({ historyWord });
        storage.save({ key: 'historyWord', data: historyWord });
    }

    // 转Web后onSubmitEditing事件不触发，兼容处理
    webSaveKeyWord = (event) => {
        const { keyWord } = this.state;

        if (event.key === 'Enter') {
            if (!keyWord.trim()) { return; }
            this.textChange(keyWord, this.saveKeyWord);
        }
    }

    subMitEditing(value) {
        if (!value.trim()) { return; };
        this.textChange(value, this.saveKeyWord);
    }

    saveKeyWord(value) {
        const historyWord = this.state.historyWord.slice(0);

        if (historyWord.indexOf(value) === -1) {
            historyWord.unshift(value);
            if (historyWord.length > 8) {
                historyWord.pop();
            }

            storage.save({ key: 'historyWord', data: historyWord });
            this.setState({ historyWord });
        }
    }

    close() {
        this.setState({ keyWord: '', loading: false, wifiOut: false });
    }

    goBack() {
        const { keyWord } = this.state;

        mta('SearchCancel', 'Search', keyWord);
        this.context.router.pop();
    }

    toMovieList(cinemaId) {
        this.refs.textInput.refs.input.blur();
        const { keyWord } = this.state;

        this.saveKeyWord(keyWord);
        mta('SearchListItem', 'Search', `${cinemaId}_${keyWord}`);
        saveLocal('keyWord', keyWord);
        this.context.router.toMovieList({ cinemaId });
    }

    saveWordAndJump(movieInfo, type) {
        this.refs.textInput.refs.input.blur();
        const { keyWord } = this.state;

        this.saveKeyWord(keyWord);
        const { movieId } = movieInfo;

        saveLocal('keyWord', keyWord);
        if (type === 'detail') {
            this.context.router.toMovieDetail({ movieId });
        }

        if (type === 'buy') {
            this.context.router.toMovieSchedule({ movieId });
        }
    }

    moreCinema() {
        const { keyWord } = this.state;

        saveLocal('keyWord', keyWord);
        this.context.router.toRelatedCinema();
    }

    refresh() {
        const { keyWord } = this.state;

        this.setState({ wifiOut: false });
        this.textChange(keyWord);
    }
}

Search.contextTypes = {
    router: PropTypes.object
};

const select = (state) => {
    const { cur_city, lbs, lbsCity } = state.index;

    return { cur_city, lbs, lbsCity };
};

export default connect(select, null, null, { withRef: true })(Search);